import * as Sentry from "@sentry/react";
import axios from "axios";
import { NotificationsStoreContextType } from "../stores/NotificationsStore/NotificationsStore";

export enum ErrorMessages {
  SERVER_ERROR = "Server error 500: Internal server error. Please try again later.",
  CLIENT_ERROR = "Client error: Invalid request. Please check your input and try again.",
  UNKNOWN_ERROR = "An unexpected error occurred. Please try again later.",
}

export const handleFetchError = (
  error: unknown,
  notificationStore: NotificationsStoreContextType | null,
  context: string
) => {
  if (axios.isAxiosError(error) && error.response) {
    const status = error.response.status;
    if (status >= 500 && status < 600) {
      notificationStore?.showNotifiсation(
        "warning",
        ErrorMessages.SERVER_ERROR
      );
    } else if (status >= 400 && status < 500) {
      notificationStore?.showNotifiсation(
        "warning",
        ErrorMessages.CLIENT_ERROR
      );
    } else {
      notificationStore?.showNotifiсation(
        "warning",
        ErrorMessages.UNKNOWN_ERROR
      );
    }
  }
  handleError(error, context);
};

export const handleError = (error: unknown, context?: string): void => {
  if (axios.isAxiosError(error)) {
    if (import.meta.env.VITE_SENTRY_ENVIRONMENT === "production") {
      Sentry.captureException(error, {
        tags: { type: "AxiosError", context },
      });
    }
    console.error(
      `Axios error${context ? ` in ${context}` : ""}:`,
      error.message
    );
    return;
  }

  if (error instanceof Error) {
    if (import.meta.env.VITE_SENTRY_ENVIRONMENT === "production") {
      Sentry.captureException(error, {
        tags: { type: "Error", context },
      });
    }
    console.error(
      `Unknown error${context ? ` in ${context}` : ""}:`,
      error.message
    );
    return;
  }

  const unknownError = new Error("Unknown error of the type");
  if (import.meta.env.VITE_SENTRY_ENVIRONMENT === "production") {
    Sentry.captureException(unknownError, {
      tags: { type: "UnknownError", context },
    });
  }
  console.error(`Unknown error${context ? ` in ${context}` : ""}`);
};
